import React, { createContext, useReducer, useEffect } from "react";

// Create context
export const LanguageContext = createContext();

// Supported languages
const supportedLanguages = ["en", "hi", "bho", "pa"];

// Initial state
const initialState = {
  language: localStorage.getItem("language") || "en",
};

// Reducer
const languageReducer = (state, action) => {
  switch (action.type) {
    case "SET_LANGUAGE":
      if (supportedLanguages.includes(action.payload)) {
        localStorage.setItem("language", action.payload);
        return { ...state, language: action.payload };
      }
      return state;
    default:
      return state;
  }
};

// Provider
export const LanguageProvider = ({ children }) => {
  const [state, dispatch] = useReducer(languageReducer, initialState);

  useEffect(() => {
    localStorage.setItem("language", state.language);
  }, [state.language]);

  return (
    <LanguageContext.Provider value={{ state, dispatch }}>
      {children}
    </LanguageContext.Provider>
  );
};
